import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Capacitor } from '@capacitor/core';
import { HelperService } from 'src/app/public/helper.service';
import { Category } from 'src/app/stores/stores';

@Component({
  selector: 'app-default-category-tiles',
  templateUrl: './default-category-tiles.component.html',
  styleUrls: ['./default-category-tiles.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DefaultCategoryTilesComponent implements OnInit, AfterViewInit {
  @Input() topLevelCategories: Category[];
  @Input() hasOtherTopLevelCategories: boolean;
  @Input() selectedTopCat: number;
  @Input() gutterBottom: boolean = false;
  @Input() marginBottom: number = 0;

  @Output() categorySelected = new EventEmitter<number>();
  @Output() viewToggle = new EventEmitter<void>();

  @ViewChild('scrollContainer') scrollContainer: ElementRef<HTMLDivElement>;

  isGoApp = false;
  isIOSApp: boolean;
  currentStyles = {};
  isOverflowing = false;

  constructor(
    private helper: HelperService,
    private sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.isGoApp = this.helper.isGoApp();
    this.isIOSApp = Capacitor.getPlatform() === 'ios';
    this.updateStyles();
  }

  ngAfterViewInit(): void {
    this.updateOverflowState();
  }

  onSelectTopLevelCategory(categoryId: number) {
    this.categorySelected.emit(categoryId);
  }

  onViewToggle() {
    this.viewToggle.emit();
  }

  onScroll() {
    this.updateOverflowState();
  }

  private updateOverflowState() {
    const el = this.scrollContainer?.nativeElement;
    if (!el) return;
    this.isOverflowing = el.scrollWidth > el.clientWidth;
    this.cdr.markForCheck();
  }

  getBackgroundImage(url: string) {
    if (url && /^https?:\/\//.test(url)) {
      return this.sanitizer.bypassSecurityTrustStyle(`url('${url}')`);
    }
    return '';
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.updateStyles();
    this.updateOverflowState();
  }

  updateStyles() {
    const screenHeight = window.innerHeight;
    this.currentStyles = this.helper.calcPaddingBottom(
      screenHeight,
      this.isIOSApp,
      this.marginBottom,
      this.isGoApp,
    );
  }

  trackByCategoryId(_index: number, category: Category): number {
    return category.categoryId;
  }
}
